export default "__VITE_ASSET__Cz69LCPg__"